// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuickStartActionSection-module__checkIconLink--jmHUh{display:block;padding:.5rem;transition:all .1s ease-in-out}.QuickStartActionSection-module__checkIconLink--jmHUh:hover{transform:scale(1.2)}.QuickStartActionSection-module__checkIcon--ir9a6{display:block;width:1.25rem;height:1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkIconLink": "QuickStartActionSection-module__checkIconLink--jmHUh",
	"checkIcon": "QuickStartActionSection-module__checkIcon--ir9a6"
};
export default ___CSS_LOADER_EXPORT___;
